import { BaseModel } from "sjs-base-model";

export default class CommissioneBancaSegnalante extends BaseModel {
    public readonly percentuale: number = 0;
    public readonly importo: number = 0;
    public readonly descrizione: null | string = null;
    constructor(data: Partial<CommissioneBancaSegnalante>) {
        super();

        this.update(data);
    }
}
